import {Component, OnInit} from '@angular/core';
import {DocumentModel} from '../../models/document.model';
import {AlertController, LoadingController, ModalController} from '@ionic/angular';
import {StockTakeZoneResourceService} from '../../services/database/resource/stock-take-zone-resource.service';
import {TestConnectionService} from '../../services/test-connection.service';
import {NewDocumentService} from '../../services/new-document.service';
import {StateManagerService} from '../../services/state-manager.service';
import {CollectionsNames} from '../../definitions/collections-names';
import {GeneralService} from '../../services/general.service';
import {StockTakeDetailComponent} from '../stock-take-detail/stock-take-detail.component';
import {SyncStockCountService} from '../../services/sync-stock-count.service';

@Component({
    selector: 'app-stock-take-main',
    templateUrl: './stock-take-main.component.html',
    styleUrls: ['./stock-take-main.component.scss'],
})
export class StockTakeMainComponent implements OnInit {

    stockCountList: DocumentModel[];
    queryText = '';
    showNewCountOption: boolean;
    zoneNewCount: string;
    loading: any;

    constructor(private loadingController: LoadingController,
                private stockTakeZoneResource: StockTakeZoneResourceService,
                private testConnectionService: TestConnectionService,
                private newDocumentService: NewDocumentService,
                public modalController: ModalController,
                private stateManager: StateManagerService,
                private collectionNames: CollectionsNames,
                private alertController: AlertController,
                private generalService: GeneralService,
                private syncStockCountService: SyncStockCountService) {
    }

    ngOnInit() {
    }

    ionViewWillEnter() {
        this.stockCountList = this.stateManager.getCollection(this.collectionNames.STOCKCOUNTS);
        console.log(this.stockCountList);
    }

    async checkZoneForCounting() {
        // Check in the backend if the zone is valid
        try {
            await this.loadingSpinner();
            await this.testConnectionService.pingServer();
            const newZone = await this.stockTakeZoneResource.checkZone(this.zoneNewCount) as any;
            console.log(newZone);
            if (newZone && newZone.status === 'SUCCESS') {
                // Create a new count if valid
                this.showNewCountOption = false;
                let newDocument = this.newDocumentService.genNewDocument();
                newDocument.documentType = newZone.result;
                newDocument.comment = this.zoneNewCount;
                this.stateManager.upsert(this.collectionNames.STOCKCOUNTS, '$loki', newDocument);
                newDocument = this.stateManager.getCollection(this.collectionNames.STOCKCOUNTS).find(stockCount => {
                    return stockCount.comment === newDocument.comment && newDocument.documentType === stockCount.documentType;
                });
                this.stateManager.saveDatabase();
                this.stockTakeModal(newDocument);
                this.zoneNewCount = '';
            } else {
                this.alertInvalidZone();
            }
        } catch (e) {
            console.log(e);
            this.generalService.createToast('No connection to the server');
        }
        await this.loading.dismiss();
    }


    async loadingSpinner() {
        // Spawns the modal for new count
        await this.loadingController.create({
            message: 'Checking zone...',
            translucent: true,
            cssClass: 'custom-class custom-loading',
            spinner: 'bubbles'
        }).then((overlay) => {
            this.loading = overlay;
            this.loading.present();
        });
    }

    async stockTakeModal(stockCount: DocumentModel) {
        console.log(stockCount);
        const modal = await this.modalController.create({
            component: StockTakeDetailComponent,
            backdropDismiss: false,
            cssClass: 'modal-fullscreen',
            componentProps: {
                stockCount: stockCount
            }
        });
        modal.onDidDismiss().then(() => {
            this.ionViewWillEnter();
        });
        return await modal.present();
    }

    async alertInvalidZone() {
        const alert = await this.alertController.create({
            header: 'Invalid Zone',
            message: 'This zone is already registered in the system. Please check.',
            buttons: ['OK']
        });

        await alert.present();
    }

    async uploadStockCounts() {
        for (const stockCount of this.stockCountList) {
            await this.syncStockCountService.syncStockCount(stockCount);
        }
        this.stateManager.saveDatabase();
        this.ionViewWillEnter();
    }

    closeModal() {
        this.modalController.dismiss();
    }
}
